import { LitElement, html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { style } from './searchBar.style';
import rp from '../global';

@customElement('rp-app-search')
export class SearchBar extends LitElement {

	static styles = style;

	@property({type: String})
	text: string = '';
	
	@query('.bar')
	bar: HTMLDivElement;
	
	
	_onClick = () => {
		rp.host?.openCommands();
	}

	render = () => html`
		<div class="bar" @click="${this._onClick}">
			<div class="bar-icon">
				<og-icon icon="search"></og-icon>
			</div>
			<div class="bar-text">${this.text}</div>
		</div>
	`;
	
}
